import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText, Icon } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineBoxList.js';
import { CSSTransition } from 'react-transition-group';


class EngineBoxList extends React.Component {
  static displayName = 'EngineBoxList';
  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
  }

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  toggleBox = () => {
    const {
      focusOnModalView,
      toggleBox,
      showModalView,
      modalBreak
    } = this.props.config;

    let toggleBoxFn = toggleBox(true, 'list');
    
    if (modalBreak && !showModalView && !focusOnModalView) {
      toggleBoxFn =  toggleBox(false, 'pending');
    }

    return toggleBoxFn
  }

  handleFocus = (event) => {
    if (event.relatedTarget) {
      return;
    }
    this.props.config.clearSearch();
  };

  showElements = (placeHolder) => {

    const { config, theme, content } = this.props;
    const {
      value,
      clearSearch,
      onChangeValue,
      onKeyDownSearchBox,
      match,
      matchedText,
    } = config;
    const { classes } = theme.styles

    const parseDynamicText = (html) => {
      if (!html) return '';
      return html.replace(/<\/?strong[^>]*>/g, ''); // Limpiar etiquetas <strong>
    };
  
    let matchTextCont = parseDynamicText(matchedText);

    return (<>
      <Icon unicodeContent={'e088'} innerStyle={classes.iconsEngine} />
      <input
        autoComplete="off"
        onClick={this.toggleBox()}
        onChange={onChangeValue}
        onFocus={this.handleFocus}
        value={value}
        className={classes.searchBoxInput}
        placeholder={placeHolder}
        onKeyDown={onKeyDownSearchBox}
        ref={this.refSearchBox}
        id={this.refSearchBox}
        aria-autocomplete='both'
      />
      {match && (
        <div
          aria-live='polite'
          aria-atomic='true'
          dangerouslySetInnerHTML={{ __html: matchedText }}
          className={classes.matchedText} 
          {...(matchedText && { 'aria-label': content.t('_%coincidencia texto%_') + matchTextCont })}
        />
      )}
    </>)
  }


  render() {
    const { config, theme, content } = this.props;
    const {
      visibleType,
      dropDown,
      showModalView,
      modalBreak
    } = config;
    const { classes } = theme.styles

    //Desktop  version
    if(!modalBreak){
      //extraFields for portalDesing
      const extraLabelText = theme.theme === 'portalDesign' ? (
        <RichText
          translate={true}
          text={'_%¿A dónde te gustaría ir?%_'}
          ucFirst={true}
          innerStyle={classes.inputEngineTitle}
        />
      ) : null;


      return (<div className={[theme.computedInnerStyle].join(' ')} tabIndex={0} aria-label={content.t('_%buscar un destino%_')}>
        <label className={classes.searchContainerChildren}>
          {extraLabelText}
          {this.showElements(content.t('_%Elige el destino o el hotel%_'))}
        </label>
      </div>)
    }

    //Not desktop version
    const placeHolder = showModalView ? '_%Elige el destino o el hotel%_' : '_%¿A dónde te gustaría ir?%_'
    return (
      <CSSTransition
        in={visibleType === 'list' || !dropDown}
        timeout={700}
        mountOnEnter
        unmountOnExit
        classNames={{
          enter: classes.inputEnter,
          enterActive: classes.inputEnterActive,
          exit: classes.inputLeave,
          exitActive: classes.inputLeaveActive
        }}
      >
        <div className={[theme.computedInnerStyle, this.cx({dispoModal:showModalView})].join(' ')} tabIndex={0} aria-label={content.t('_%buscar un destino%_')}>
          <label className={classes.searchContainerChildren}>
            {this.showElements(content.t(placeHolder))}
          </label>
        </div>
      </CSSTransition>
    );
  }
  
}

export default compose(
  PropertyManager([

'value',
'match',
'visibleType',
'dropDown',
'showModalView',
'matchedText',

'focusOnModalView',
'toggleBox',
'clearSearch',
'onChangeValue',
'onKeyDownSearchBox',
'classes',
'modalBreak',
  ]),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EngineBoxList);
